import {
  buildInboxDashboardRoute,
  buildSidebarLabelRoute,
} from './sidebarInboxNavigation';

// Pagina di apertura scelta dall'utente (ui_settings). Assente = "Tutte le
// conversazioni". La destinazione si calcola quando l'utente sceglie la
// casella e si salva gia' pronta: all'avvio il router decide prima che le
// caselle siano caricate, quindi non puo' piu' chiedere niente a nessuno.
export const LANDING_PAGE_KEY = 'landing_page';

const EMAIL_CHANNEL_TYPE = 'Channel::Email';
const INBOX_FOLDER_TITLES = ['INBOX', 'POSTA IN ARRIVO'];

const toId = (value) => {
  const id = Number(value);
  return Number.isInteger(id) && id > 0 ? id : null;
};

const isInboxFolder = (label) =>
  String(label?.source_id || '').toUpperCase() === 'INBOX' ||
  String(label?.well_known_name || '').toLowerCase() === 'inbox' ||
  INBOX_FOLDER_TITLES.includes(String(label?.title || '').toUpperCase());

export const isEmailInbox = (inbox) =>
  inbox?.channel_type === EMAIL_CHANNEL_TYPE;

export function findInboxFolderLabel(labels) {
  return (Array.isArray(labels) ? labels : []).find(isInboxFolder) || null;
}

export function resolveLandingInboxId(uiSettings) {
  return toId(uiSettings?.[LANDING_PAGE_KEY]?.inbox_id);
}

// Caselle con le cartelle (Gmail, Outlook, IMAP sincronizzato): si atterra
// nella Posta in arrivo, come cliccando la cartella. Tutte le altre: la
// lista della casella.
export function buildLandingPageSettings({ accountId, inbox, labels } = {}) {
  const inboxId = toId(inbox?.id);
  if (!inboxId) return { [LANDING_PAGE_KEY]: null };

  const folder = isEmailInbox(inbox) ? findInboxFolderLabel(labels) : null;
  const { query } = folder
    ? buildSidebarLabelRoute({ accountId, inboxId, label: folder })
    : { query: {} };

  return {
    [LANDING_PAGE_KEY]: {
      account_id: toId(accountId),
      inbox_id: inboxId,
      query: JSON.parse(JSON.stringify(query)),
    },
  };
}

// Vale quando si ENTRA nella sezione conversazioni: apertura di Otello,
// oppure ritorno da impostazioni, contatti e simili. Dentro la sezione il link
// "Tutte le conversazioni" e i link con filtri devono continuare a portare li'.
export function resolveLandingRoute({
  to,
  from,
  uiSettings,
  conversationRouteNames = [],
} = {}) {
  if (to?.name !== 'home') return null;
  if (conversationRouteNames.includes(from?.name)) return null;
  if (Object.keys(to?.query || {}).length) return null;

  const landingPage = uiSettings?.[LANDING_PAGE_KEY];
  const inboxId = resolveLandingInboxId(uiSettings);
  const accountId = toId(to?.params?.accountId);
  if (!inboxId || !accountId) return null;
  if (toId(landingPage.account_id) !== accountId) return null;

  return buildInboxDashboardRoute({
    accountId,
    inboxId,
    query: { ...(landingPage.query || {}) },
  });
}

// La casella scelta non c'e' piu' (cancellata, o l'utente ne e' stato tolto).
export function isLandingInboxMissing({ accountId, uiSettings, inboxes } = {}) {
  const inboxId = resolveLandingInboxId(uiSettings);
  if (!inboxId) return false;
  // Le caselle sono quelle dell'account aperto: la scelta fatta su un altro
  // account non si giudica da qui.
  if (toId(uiSettings[LANDING_PAGE_KEY].account_id) !== toId(accountId)) {
    return false;
  }
  return !(Array.isArray(inboxes) ? inboxes : []).some(
    (inbox) => toId(inbox?.id) === inboxId
  );
}
